import React, {Component} from 'react'
import Links from "../../../Route";
import HttpRequest from "../../../HttpRequest";
import Components from "../../../components";
import {Tools} from "../../../Tools";
import Tabs from "../../../components/Tabs";
import Contributions from "./Contributions";
import {TEMPLATE_PAGE_IN_CONSTRUCTION} from "../../index";
import Member from "./Member";
import AuthenticationAPI from "../../../services/AuthenticationAPI";
import Route from "../../../Route";
import Loader from "../../../components/Loader";
import Reports from "../Admin/Reports";
import EditMember from "./EditMember";

const
    menuKey = {
        profile: "profile",
        contributions: "contributions",
        contribution_repository: "contribution_repository",
        association_texts: "association_texts",
    },
    pages = {
        "profile" : menuKey.profile,
        "my-contributions" : menuKey.contributions,
        "contribution-repository" : menuKey.contribution_repository,
        "association_texts" : menuKey.association_texts,
    },
    defaultMenuKey = menuKey.profile,
    menu = [
        {
            key: menuKey.profile,
            type: "a",
            className: "nav-link",
            href: "#",
            label: "Mon profil",
            handleClick: null,
            attributes: {
                "data-key": menuKey.profile
            },
            tabs: [
                {
                    type: "button",
                    className: "btn btn-tab ",
                    label: "Mon profil",
                    attributes: {
                        "data-key": Member.Views.my_profile.id
                    },
                    handleClick: null,
                    component: <Member view={Member.Views.my_profile} key={Member.Views.my_profile.id} />
                },
                {
                    type: "button",
                    className: "btn btn-tab ",
                    label: "Modifier mon profil",
                    attributes: {
                        "data-key": Member.Views.edit_profile.id
                    },
                    handleClick: null,
                    component: <EditMember view={Member.Views.edit_profile} key={Member.Views.edit_profile.id} />
                },
                {
                    type: "button",
                    className: "btn btn-tab ",
                    label: "Modifier l'email & le mot de passe",
                    attributes: {
                        "data-key": Member.Views.edit_email_and_pwd.id
                    },
                    handleClick: null,
                    component: <Member view={Member.Views.edit_email_and_pwd} key={Member.Views.edit_email_and_pwd.id} />
                },
            ]
        },
        {
            key: menuKey.contributions,
            type: "a",
            className: "nav-link",
            href: "#",
            label: "Mes cotisations",
            handleClick: null,
            attributes: {
                "data-key": menuKey.contributions
            },
            tabs: [
                {
                    type: "button",
                    className: "btn btn-tab ",
                    label: "Cotisations pas encore payées",
                    attributes: {
                        "data-key": Contributions.Views.not_paid_contribution.id
                    },
                    handleClick: null,
                    component: <Contributions view={Contributions.Views.not_paid_contribution} key={Contributions.Views.not_paid_contribution.id} />
                },
                {
                    type: "button",
                    className: "btn btn-tab",
                    label: "Cotisations payées",
                    attributes: {
                        "data-key": Contributions.Views.paid_contribution.id
                    },
                    handleClick: null,
                    component: <Contributions view={Contributions.Views.paid_contribution} key={Contributions.Views.paid_contribution.id} />
                }
            ]
        },
        {
            key: menuKey.contribution_repository,
            type: "a",
            className: "nav-link",
            href: "#",
            label: "Référentiel des cotisations",
            handleClick: null,
            attributes: {
                "data-key": menuKey.contribution_repository
            },
            tabs: [
                {
                    type: "button",
                    className: "btn btn-tab",
                    label: "Cotisations ouvertes",
                    attributes: {
                        "data-key": Contributions.Views.open_contribution.id
                    },
                    handleClick: null,
                    component: <Contributions view={Contributions.Views.open_contribution} key={Contributions.Views.open_contribution.id} />
                },
                {
                    type: "button",
                    className: "btn btn-tab ",
                    label: "Cotisations avenir",
                    attributes: {
                        "data-key": Contributions.Views.futures_contribution.id
                    },
                    handleClick: null,
                    component: <Contributions view={Contributions.Views.futures_contribution} key={Contributions.Views.futures_contribution.id} />
                }
            ]
        },
        {
            key: menuKey.association_texts,
            type: "a",
            className: "nav-link",
            href: "#",
            label: "Les textes de l'association",
            handleClick: null,
            attributes: {
                "data-key": menuKey.association_texts
            },
        },
    ]
;

class MemberProfile extends Component{

    static menuKey = menuKey;
    constructor(props) {
        super(props);
        this.httpClient = new HttpRequest();

        this.currentPage = props.match.params.page;
        let activeMenu = defaultMenuKey;
        if(pages[this.currentPage]){
            activeMenu = pages[this.currentPage];
        }

        this.state = {
            server: {},
            activeMenu: activeMenu,
            hasRequestInProgress: false,
            isLoadCompleted: false,
            hasPageError: false,
            hasError: false,
            currentPage: props.match.params.page
        };
        this.handleMenuTopClick = this.handleMenuTopClick.bind(this);
        this.handleTabSelected = this.handleTabSelected.bind(this);
    }

    handleMenuTopClick(event){
        const activeMenu = event.target.getAttribute("data-key");
        if(this.state.activeMenu !== activeMenu){
            if(AuthenticationAPI.hasTempPassword() && activeMenu !== menuKey.profile){
                alert("Vous devez obligatoirement modifier le mot de passe temporaire !");
                return;
            }

            this.setState({activeMenu: activeMenu, hasRequestInProgress: false, selectedTab: 0});
        }
    }

    handleTabSelected(selectedTab, target){
        const activeTab = target.getAttribute("data-key");
        if(AuthenticationAPI.hasTempPassword() && activeTab !== Member.Views.edit_email_and_pwd.id){
            alert("Vous devez obligatoirement modifier le mot de passe temporaire !");
            return false;
        }
    }

    static getTabsByMenuKey(key){
        const menuItem = Tools.GetItem("key", key, menu);
        return menuItem.tabs ? menuItem.tabs : [];
    }

    /**
     *
     * @return {JSX.Element}
     */
    render() {
        let menuContent = <></>;
        if(!this.state.isLoadCompleted){
            menuContent = <Loader />;
        }
        else if(this.state.member && this.state.activeMenu){
            switch (this.state.activeMenu){
                case menuKey.profile:
                case menuKey.contributions:
                case menuKey.contribution_repository:
                    const tabs = MemberProfile.getTabsByMenuKey(this.state.activeMenu);
                    let selectedTab = this.state.selectedTab ? this.state.selectedTab : 0;
                    menuContent = <Tabs
                        key={this.state.activeMenu}
                        defaultTabSelected={tabs[selectedTab].attributes["data-key"]}
                        tabs={tabs}
                        handleTabSelected={this.handleTabSelected} />;
                    break;
                case menuKey.association_texts:
                    menuContent = <Reports url={Route.APIMembersAssociationTexts} />;
                    break;
                default:
                    menuContent = TEMPLATE_PAGE_IN_CONSTRUCTION;
                    break;
            }
        }

        return (
            <>
                <div className="inner-head bg-animate">
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-md-8 col-md-offset-2">
                                <h3>{Links.MemberProfile.label}</h3>
                                {
                                    AuthenticationAPI.roleLabels[AuthenticationAPI.userRole()] ?
                                        <h6 className="text-white">
                                            Login : {AuthenticationAPI.getCurrentUser().email}
                                            <br/>
                                            Rôle d'accès : {AuthenticationAPI.roleLabels[AuthenticationAPI.userRole()]}
                                        </h6>
                                        : ""
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="inner-page">
                    <div className="container-fluid">
                        <div className="row admin-font-size">
                            <div className="col-md-3">
                                <aside>
                                    <div className="aside-navbar">
                                        <Components.Specifics.AsideMenu handleClick={this.handleMenuTopClick} data={{
                                            menu: menu,
                                            activeMenu: this.state.activeMenu
                                        }} />
                                    </div>
                                </aside>
                            </div>
                            <div className="col-md-9">
                                {menuContent}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    componentDidMount() {
        const _self = this;
        if(AuthenticationAPI.getCurrentUser()){
            if(AuthenticationAPI.hasTempPassword()){
                _self.setState({
                    member: {email: AuthenticationAPI.getCurrentUser().email, hasTempPassword: true},
                    isLoadCompleted: true, activeMenu: menuKey.profile, selectedTab: 2
                });
            }
            else{
                this.httpClient.request(Route.APIMembersProfile + AuthenticationAPI.user.accessToken, "GET", {}).then(function (response){
                    _self.server = response;
                    let state = {isLoadCompleted: true, ...response.data };
                    if(response.data && response.data.member && response.data.member.hasTempPassword){
                        state = {...state, activeMenu: menuKey.profile, selectedTab: 2}
                    }
                    _self.setState({...state});
                }).catch(function (error){
                    _self.server = error;
                    _self.setState({server: error, hasError: true });
                });
            }
        }
    }
}

export default MemberProfile;